import { cardItems } from '@/mocks/homeData';

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">精选推荐</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">精选推荐</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">编辑团队精选的高清影视在线观看深度内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.slice(0, 6).map((item, idx) => (
            <div key={idx} className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all">
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">{item.category}</span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.summary}</p>
              </div>
            </div>
          ))}
          <div className="sm:col-span-2 lg:col-span-3 bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer group">
            <div className="flex flex-col md:flex-row">
              <div className="md:w-1/3 aspect-[16/10] md:aspect-auto overflow-hidden bg-background-200">
                <img
                  src={cardItems[6].image}
                  alt={cardItems[6].title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">{cardItems[6].category}</span>
                  <span className="text-xs text-foreground-400">{cardItems[6].date}</span>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{cardItems[6].title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{cardItems[6].summary}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}